import React, { useState, useEffect } from "react";
import classnames from "classnames";
import Validator from "validator";
import { Stats } from "./Stats"
import { getCountries } from "../../actions/countriesActions";
import { getZipCode } from "../../actions/zipcodeActions";
import materialize from "materialize-css";
import { set } from "mongoose";


export const PersonalInformationEstudiante = (props) => {

  const [countries, setCountries] = useState([]);
  //const [countriesFull, setCountriesFull] = useState([]);
  const [errorEmail, setErrorEmail] = useState('');
  const [errorNombre, setErrorNombre] = useState('');
  const [errorApellido, setErrorApellido] = useState('');
  const [errorCelular, setErrorCelular] = useState('');
  const [errorWhatsapp, setErrorWhatsapp] = useState('');
  const [errorNacimiento, setErrorNacimiento] = useState('');
  const [errorSexo, setErrorSexo] = useState('');
  const [errorPais, setErrorPais] = useState('');
  const [errorCiudad, setErrorCiudad] = useState('');
  const [errorCodigoPostal, setErrorCodigoPostal] = useState('');
  const [errorPropositoVisita, setErrorPropositoVisita] = useState('');
  const [errorTipoInstitucion, setErrorTipoInstitucion] = useState('');
  const [errorCarrera, setErrorCarrera] = useState('');
  const [errorVisita, setErrorVisita] = useState('');

  let error ="";

  const update = (e) => {
    props.update(e.target.id, e.target.value);
  };

  const validate = async () => {

    console.log(props.form);

    let valid = true;
    let language = localStorage.getItem("exmi_language");

    // Errors clean up
    setErrorEmail("");
    setErrorNombre("");
    setErrorApellido("");
    setErrorCelular("");
    setErrorWhatsapp("");
    setErrorNacimiento("");
    setErrorSexo("");
    setErrorPais("");
    setErrorCiudad("");
    setErrorCodigoPostal("");

    setErrorPropositoVisita("");
    setErrorTipoInstitucion("");
    setErrorCarrera("");
    setErrorVisita("");

    if (language === "es") {
      // Email checks
      if (Validator.isEmpty(props.form.email)) {
        setErrorEmail("Email es requerido");
        valid = false;
      } else if (!Validator.isEmail(props.form.email)) {
        setErrorEmail("Email es invalido");
        valid = false;
      }

      // Nombres
      if (Validator.isEmpty(props.form.nombres)) {
        setErrorNombre("Nombre es requerido");
        valid = false;
      }

      // Apellidos
      if (Validator.isEmpty(props.form.apellidos)) {
        setErrorApellido("Apellido es requerido");
        valid = false;
      }

      // Celular
      if (!Validator.isEmpty(props.form.celular)) {
        if (Validator.isInt(props.form.celular)) {
          if (!Validator.isLength(props.form.celular, { min: 10, max: 10 })) {
            setErrorCelular("Numero de Celular Invalido, numero esperado a 10 digitos");
            valid = false;
            }
          }
        else {
              setErrorCelular("Numero de Celular Invalido, numero esperado a 10 digitos");
              valid = false;
              }
        }
        else {
              setErrorCelular("Numero de Celular es requerido");
              valid = false;
            }


      // Whatsapp
      if (!Validator.isEmpty(props.form.whatsapp)) {
        if (Validator.isInt(props.form.whatsapp)) {
          if (!Validator.isLength(props.form.whatsapp, { min: 10, max: 10 })) {
            setErrorWhatsapp("Numero de WhatsApp Invalido, numero esperado a 10 digitos");
            valid = false;
          }
        }
        else {
          setErrorWhatsapp("Numero de WhatsApp Invalido, numero esperado a 10 digitos");
          valid = false;
        }
      }


      // Año de nacimiento
      if (Validator.isEmpty(props.form.nacimiento)) {
        setErrorNacimiento("Año de nacimiento es requerido (ej. 1982)");
        valid = false;
      }
      else if (!Validator.isInt(props.form.nacimiento)) {
        setErrorNacimiento("Año de nacimiento invalido (ej. 1982)");
        valid = false;
      }

      // Género
      if (Validator.isEmpty(props.form.sexo)) {
        setErrorSexo("Género es requerido");
        valid = false;
      }

      // Ciudad
      if (props.form.pais !== "MX" && props.form.pais !== "US") {
        if (Validator.isEmpty(props.form.ciudad)) {
          setErrorCiudad("Ciudad es requerida");
          valid = false;
        }
      }

      // Pais
      if (Validator.isEmpty(props.form.pais)) {
        setErrorPais("Pais es requerido");
        valid = false;
      }

      // Código Postal
      if (Validator.isEmpty(props.form.codigoPostal)) {
        setErrorCodigoPostal("Código Postal es requerido");
        valid = false;
      } else if (props.form.pais === "MX" || props.form.pais === "US") {

        if (!Validator.isInt(props.form.codigoPostal)) {
          setErrorCodigoPostal("Código Postal invalido, debe ser numérico");
          valid = false;
        }
        else {
          await getZipCode(props.form.pais, props.form.codigoPostal)
            .then(response => {

              if (response.data === null) {
                setErrorCodigoPostal("Código Postal invalido");
                props.update("estado", "");
                props.update("ciudad", "");
                //props.update("telefonoCodigoPais","");
                valid = false;
              }
              else {
                props.update("estado", response.data.stateName);
                props.update("ciudad", response.data.city);
                /*
                let country = countriesFull.find(pais=> pais.name == props.form.pais);
                if (country !== undefined)
                  props.update("telefonoCodigoPais", country.phone_code);
                */
              }
            });
        }
      }
      
    if (Validator.isEmpty(props.form.propositoVisita) || props.form.propositoVisita === "-1") {
        setErrorPropositoVisita("Propósito de la visita es requerido");
        valid = false;
    }

    if (Validator.isEmpty(props.form.tipoInstitucion) || props.form.tipoInstitucion === "-1") {
        setErrorTipoInstitucion("Tipo de Institución es requerido");
        valid = false;
    }   

    if (Validator.isEmpty(props.form.carreraEspecialidad) || props.form.carreraEspecialidad === "-1") {
        setErrorCarrera("Carrera es requerida");
        valid = false;
    }   

    if (Validator.isEmpty(props.form.visita) || props.form.visita === "-1") {
        setErrorVisita("Visita es requerida");
        valid = false;
    }
    }
    else {
      // Email checks
      if (Validator.isEmpty(props.form.email)) {
        setErrorEmail("Email is Required");
        valid = false;
      } else if (!Validator.isEmail(props.form.email)) {
        setErrorEmail("Email is Invalid");
        valid = false;
      }

      // Nombres
      if (Validator.isEmpty(props.form.nombres)) {
        setErrorNombre("First Name is Required");
        valid = false;
      }

      // Apellidos
      if (Validator.isEmpty(props.form.apellidos)) {
        setErrorApellido("Last Name is Required");
        valid = false;
      }

      // Celular
      if (!Validator.isEmpty(props.form.celular)) {
        if (Validator.isInt(props.form.celular)) {
          if (!Validator.isLength(props.form.celular, { min: 10, max: 10 })) {
            setErrorCelular("Mobile number Invalid, expected number to 10 digits expected");
            valid = false;
          }
        }
        else {
          setErrorCelular("Mobile number Invalid, expected number to 10 digits");
          valid = false;
        }

      }
      else {
        setErrorCelular("Mobile phone number is required");
        error = "Mobile phone number is required";
        valid = false;
      }

      // Whatsapp
      if (!Validator.isEmpty(props.form.whatsapp)) {
        if (Validator.isInt(props.form.whatsapp)) {
          if (!Validator.isLength(props.form.whatsapp, { min: 10, max: 10 })) {
            setErrorWhatsapp("Invalid WhatsApp number, expected number with 10 digits");
            valid = false;
          }
        }
        else {
          setErrorWhatsapp("Invalid WhatsApp number, expected number with 10 digits");
          valid = false;
        }
      }

      // Año de nacimiento
      if (Validator.isEmpty(props.form.nacimiento)) {
        setErrorNacimiento("Year of Birth is Required (ie. 1982)");
        valid = false;
      }
      else if (!Validator.isInt(props.form.nacimiento)) {
        setErrorNacimiento("Year of Birth is Invalid (ie. 1982)");
        valid = false;
      }

      // Género
      if (Validator.isEmpty(props.form.sexo)) {
        setErrorSexo("Gender is required");
        valid = false;
      }

      // Ciudad
      if (props.form.pais !== "MX" && props.form.pais !== "US") {
        if (Validator.isEmpty(props.form.ciudad)) {
          setErrorCiudad("City is Required");
          valid = false;
        }
      }

      // Pais
      if (Validator.isEmpty(props.form.pais)) {
        setErrorPais("Country is Required");
        valid = false;
      }

      // Código Postal
      if (Validator.isEmpty(props.form.codigoPostal)) {
        setErrorCodigoPostal("Zip Code is Required");
        valid = false;
      } else if (props.form.pais === "MX" || props.form.pais === "US") {

        if (!Validator.isInt(props.form.codigoPostal)) {
          setErrorCodigoPostal("Zip Code is Invalid, it must be numeric");
          valid = false;
        }
        else {
          await getZipCode(props.form.pais, props.form.codigoPostal)
            .then(response => {

              if (response.data === null) {
                setErrorCodigoPostal("Zip Code is Invalid");
                props.update("estado", "");
                props.update("ciudad", "");
                //props.update("telefonoCodigoPais","");
                valid = false;
              }
              else {
                props.update("estado", response.data.stateName);
                props.update("ciudad", response.data.city);
                
                /*
                let country = countriesFull.find(pais=> pais.name == props.form.pais);
                if (country !== undefined)
                  props.update("telefonoCodigoPais", country.phone_code);
                */
              }
            });
        }
      }
    

    if (Validator.isEmpty(props.form.propositoVisita) || props.form.propositoVisita === "-1") {
        setErrorPropositoVisita("Purpose of Visit is Required");
        valid = false;
    }  

    if (Validator.isEmpty(props.form.tipoInstitucion) || props.form.tipoInstitucion === "-1") {
        setErrorTipoInstitucion("Type of Institution is Required");
        valid = false;
    }

    if (Validator.isEmpty(props.form.carreraEspecialidad) || props.form.carreraEspecialidad === "-1") {
        setErrorCarrera("Career is Required");
        valid = false;
    }

    if (Validator.isEmpty(props.form.visita) || props.form.visita === "-1") {
        setErrorVisita("Visit is Required");
        valid = false;
    }
}




    if (valid) {
      console.log(props.form.pais);

      props.submit();
    }
  };

  useEffect(() => {
    getCountries()
      .then(response => {
        let countries = [];
        countries = response.data.map((country) => {
          return <option key={country.iso2} value={country.iso2}>{country.name}</option>
        });
        //setCountriesFull(response.data);
        setCountries(countries);
        props.update("pais", props.form.pais);
        materialize.AutoInit();
        materialize.updateTextFields();
      });
  }, []);




  return (
    <div>
      <div className="col s12 m12 l12" style={{ paddingLeft: "11.250px" }}>
        <h4>
          <b>{props.locale.dashboard_comprador_label_personalinformation}</b>
        </h4>
      </div>
      <div className="input-field col s12 m12 l12">
        <input
          disabled
          placeholder=""
          onChange={update}
          value={props.form.email}
          error={errorEmail}
          id="email"
          type="email"
           className={classnames("font-face-msb", {
            invalid: errorEmail
          })}
        />
        <label htmlFor="email" className="active">{props.locale.dashboard_comprador_label_mail}</label>
        <span className="red-text">{errorEmail}</span>
      </div>
      <div className="input-field col s12 m4 l4">
        <input
          autoFocus
          onChange={update}
          value={props.form.nombres}
          error={errorNombre}
          id="nombres"
          type="text"
           className={classnames("font-face-msb", {
            invalid: errorNombre
          })}
        />
        <label htmlFor="nombres">{props.locale.dashboard_comprador_label_name}</label>
        <span className="red-text">{errorNombre}</span>
      </div>
      <div className="input-field col s12 m4 l4">
        <input
          onChange={update}
          value={props.form.apellidos}
          error={errorApellido}
          id="apellidos"
          type="text"
           className={classnames("font-face-msb", {
            invalid: errorApellido
          })}
        />
        <label htmlFor="apellidos">{props.locale.dashboard_comprador_label_lastname}</label>
        <span className="red-text">{errorApellido}</span>
      </div>
      <div className="input-field col s12 m4 l4">
        <select value={props.form.pais} onChange={update} id="pais">
          <option value="" disabled>
            {props.locale.dashboard_comprador_label_country}
          </option>
          {countries}
        </select>
        <label>{props.locale.dashboard_comprador_label_country_select}</label>
        <span className="red-text">{errorPais}</span>
      </div>
      <div className="input-field col s12 m4 l4">
        <input
          onChange={update}
          value={props.form.codigoPostal}
          error={errorCodigoPostal}
          id="codigoPostal"
          type="text"
           className={classnames("font-face-msb", {
            invalid: errorCodigoPostal
          })}
          maxLength="11"
          onKeyPress={(event) => { if ((props.form.pais === "MX" || props.form.pais === "US") && !/[0-9]/.test(event.key)) { event.preventDefault(); } }}
        />
        <label htmlFor="codigoPostal">{props.locale.dashboard_comprador_label_zipcode}</label>
        <span className="red-text">{errorCodigoPostal}</span>
      </div>
      {(props.form.pais !== "MX" && props.form.pais !== "US") ?
        <>
          <div className="input-field col s12 m4 l4">
            <input
              onChange={update}
              value={props.form.ciudad}
              error={errorCiudad}
              id="ciudad"
              type="text"
               className={classnames("font-face-msb", {
                invalid: errorCiudad
              })}
            />
            <label htmlFor="ciudad">{props.locale.dashboard_comprador_label_city}</label>
            <span className="red-text">{errorCiudad}</span>
          </div>
        </> :
        <></>
      }      
      <div className="input-field col s12 m4 l4">
        <input
          onChange={update}
          value={props.form.celular}
          error={errorCelular}
          id="celular"
          type="text"
           className={classnames("font-face-msb", {
            invalid: errorCelular
          })}
          maxLength="10"
          onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) { event.preventDefault(); } }}
        />
        <label htmlFor="celular">{props.locale.dashboard_comprador_label_cellphone}</label>
        <span className="red-text">{errorCelular}</span>
      </div>
      <div className="input-field col s2 m2 l2">
            <input
            disabled
                        placeholder=""
            onChange={update}
            value={props.form.telefonoCodigoPais}
            id="telefonoCodigoPais"
            type="text"
            maxLength="10"
            />
             <label htmlFor="telefonoCodigoPais">{props.locale.dashboard_comprador_label_country_code}</label>
            </div>
            <div className="input-field col s10 m2 l2">
            <input
            onChange={update}

            value={props.form.whatsapp}
            error={errorWhatsapp}
            id="whatsapp"
            type="text"
            className={classnames("font-face-msb", {
                invalid: errorWhatsapp
            })}
            maxLength="10"
            onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) { event.preventDefault(); } }}
            />
            <label htmlFor="whatsapp">{props.locale.dashboard_comprador_label_whatsapp}</label>
            <span className="red-text">{errorWhatsapp}</span>
        </div>
      <div className="input-field col s12 m4 l4">
        <input
          onChange={update}
          value={props.form.nacimiento}
          error={errorNacimiento}
          id="nacimiento"
          type="text"
           className={classnames("font-face-msb", {
            invalid: errorNacimiento
          })}
          maxLength="4"
          onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) { event.preventDefault(); } }}
        />
        <label htmlFor="nacimiento">{props.locale.dashboard_comprador_label_yearofbirth}</label>
        <span className="red-text">{errorNacimiento}</span>
      </div>

      <div className="input-field col s12 m4 l4">
        <select value={props.form.sexo} onChange={update} id="sexo">
          <option value="" disabled>
            {props.locale.dashboard_comprador_label_sex}
          </option>
          <option value="F">
            {props.locale.dashboard_comprador_label_female}
          </option>
          <option value="M">
            {props.locale.dashboard_comprador_label_male}
          </option>
          <option value="O">
            {props.locale.dashboard_comprador_label_gender_other}
          </option>
          <option value="N">
            {props.locale.dashboard_comprador_label_gender_not_specified}
          </option>
        </select>
        <label>{props.locale.dashboard_comprador_label_sex}</label>
        <span className="red-text">{errorSexo}</span>
      </div>

    <div className="input-field col s12 m4 l4">
    <select value={props.form.propositoVisita} onChange={update} id="propositoVisita">
        <option value="-1" selected>
        {props.locale.dashboard_comprador_label_comprador_proposito_visita_b2c_seleccione}
        </option>
        <option value="Compra personal">
        {props.locale.dashboard_comprador_label_comprador_proposito_visita_b2c_proposito_visita_compra_personal}
        </option>
        <option value="Inspiración">
        {props.locale.dashboard_comprador_label_comprador_proposito_visita_b2c_proposito_visita_inspiracion}
        </option>
        <option value="Renovación">
        {props.locale.dashboard_comprador_label_comprador_proposito_visita_b2c_proposito_visita_renovacion } 
        </option>
        <option value="Conferencias">
        {props.locale.dashboard_comprador_label_comprador_proposito_visita_b2c_proposito_visita_conferencias}
        </option>
    </select>
    <label>{props.locale.dashboard_comprador_label_comprador_proposito_visita_b2c_proposito_visita}</label>
    <span className="red-text">{errorPropositoVisita}</span>
    </div>      

    <div className="input-field col s12 m4 l4">
    <select value={props.form.tipoInstitucion} onChange={update} id="tipoInstitucion">
        <option value="-1" selected>
        {props.locale.dashboard_comprador_label_comprador_proposito_visita_b2c_seleccione}
        </option>
        <option value="Universidad">
        {props.locale.dashboard_comprador_label_tipoInstitucion_universidad }
        </option>
        <option value="Técnica">
        {props.locale.dashboard_comprador_label_tipoInstitucion_tecnica}
        </option>
        <option value="Otra">
        {props.locale.dashboard_comprador_label_tipoInstitucion_otra} 
        </option>
    </select>
    <label>{props.locale.dashboard_comprador_label_tipoInstitucion_desc}</label>
    <span className="red-text">{errorTipoInstitucion}</span>
    </div> 

    <div className="input-field col s12 m4 l4">
    <select value={props.form.carreraEspecialidad} onChange={update} id="carreraEspecialidad">
        <option value="-1" selected>
        {props.locale.dashboard_comprador_label_comprador_proposito_visita_b2c_seleccione}
        </option>
        <option value="Diseño">
        {props.locale.dashboard_comprador_label_carrera_disenio }
        </option>
        <option value="Arquitectura">
        {props.locale.dashboard_comprador_label_carrera_arquitectura }
        </option>
        <option value="Marketing">
        {props.locale.dashboard_comprador_label_carrera_marketing } 
        </option>
        <option value="Otra">
        {props.locale.dashboard_comprador_label_carrera_otra }
        </option>
    </select>
    <label>{props.locale.dashboard_comprador_label_carrera_desc }</label>
    <span className="red-text">{errorCarrera}</span>
    </div>    

    <div className="input-field col s12 m4 l4">
    <select value={props.form.visita} onChange={update} id="visita">
        <option value="-1" selected>
        {props.locale.dashboard_comprador_label_comprador_proposito_visita_b2c_seleccione}
        </option>
        <option value="Individual">
        {props.locale.dashboard_comprador_label_individual}
        </option>
        <option value="Grupo (nombre de institución)">
        {props.locale.dashboard_comprador_label_grupo}
        </option>
    </select>
    <label>{props.locale.dashboard_comprador_label_visita}</label>
    <span className="red-text">{errorVisita}</span>
    </div> 


      <Stats step={1} {...props} nextStep={validate} locale={props.locale} disableSubmit={props.disableSubmit} />
    </div>

  );
};